export default __webpack_public_path__ + "a530f4aee9a13bd50156612dd71fdffd.png";